/** Run background work after loading/painting, or sooner when the user acts.
 * The deadline also restores sessions in tabs that never receive interaction. */
export function scheduleNonCriticalTask(task: () => void, delayMs = 1500): () => void {
  let finished = false;
  let idleId: number | undefined;
  let delayId: number | undefined;
  const events = ['pointerdown', 'keydown', 'focusin'] as const;

  const cleanup = () => {
    window.clearTimeout(deadlineId);
    window.clearTimeout(delayId);
    if (idleId !== undefined) window.cancelIdleCallback?.(idleId);
    window.removeEventListener('load', afterLoad);
    events.forEach(event => window.removeEventListener(event, run));
  };
  const run = () => {
    if (finished) return;
    finished = true;
    cleanup();
    task();
  };
  const afterLoad = () => {
    delayId = window.setTimeout(() => {
      if (typeof window.requestIdleCallback === 'function') {
        idleId = window.requestIdleCallback(run, { timeout: 1000 });
      } else {
        run();
      }
    }, delayMs);
  };
  const deadlineId = window.setTimeout(run, delayMs + 3500);
  events.forEach(event => window.addEventListener(event, run, { passive: true }));
  if (document.readyState === 'complete') afterLoad();
  else window.addEventListener('load', afterLoad, { once: true });

  return () => { finished = true; cleanup(); };
}
